<app-loader [isLoader]="loading"></app-loader>
<div class="content-pool-container" [formGroup]="contentMapperForm">
    <div class="header">
        <img (click)="goToContentPoolListing()" [src]="leftArrow" />
        <h2>{{contentPoolOperation}} Content Pool</h2>
    </div>

    <div class="section">
        <h3>Content Pool Information</h3>

        <div class="form-row-2">
            <div class="form-group">
                <label for="name">Content Pool Name<span class="requird">*</span></label>
                <input id="name" type="text" placeholder="Enter content pool name" class="form-input"
                    [ngClass]="{'disabled': editMode, 'is-invalid': (isSubmitted() || f['name'].touched) && f['name'].errors}"
                    autocomplete="off" formControlName="name">
                @if ((f['name'].touched || isSubmitted()) && f['name'].errors) {
                <div class="invalid-feedback">
                    @if (f['name'].errors['required']) {
                    <div>Pool name is required</div>
                    }
                </div>
                }
            </div>

            <div class="form-group">
                <label for="desc">Description</label>
                <input id="desc" type="text" placeholder="Brief description of this content pool" autocomplete="off"
                    class="form-input" formControlName="desc">
            </div>
        </div>
    </div>

    <div class="section">
        <div class="section-header">
            <h3>Filter Configuration</h3>
        </div>
        <div class="filter-clauses" formArrayName="filterQuery">
            <p class="clauses-info">This filter has {{filterQuery.controls.length}} clause{{filterQuery.controls.length
                !== 1 ? 's' : ''}}</p>

            @for (filterQueryForm of filterQuery.controls; track filterQueryForm) {
            <div class="clause" [formGroupName]="$index">
                <div class="clause-content">
                    <select class="select-input" formControlName="condition">
                        @for (option of conditionOptions; track option) {
                        <option [value]="option.value">{{option.name}}</option>
                        }
                    </select>
                    <select class="select-input" formControlName="field" (change)="onFieldChange($event,$index)">
                        @for (option of fieldName; track option) {
                        <option [value]="option.value" [disabled]="alreadyAddedKeywords[option.value] && filterQueryForm.get('field')?.value !== option.value">{{option.name}}</option>
                        }
                    </select>
                    <select class="select-input" formControlName="operator">
                        @for (option of operatorOptions; track option) {
                            @if(filterQueryForm.get('field')?.value == 'release_year' && option != 'IN' && option !=
                            'ILIKE'){
                                <option [value]="option">{{option}}</option>
                            }@else if((filterQueryForm.get('field')?.value == 'categories' || filterQueryForm.get('field')?.value == 'imdb') && (option == 'IN')){
                                <option [value]="option">{{option}}</option>
                            }@else if((filterQueryForm.get('field')?.value =='keywords' || filterQueryForm.get('field')?.value =='topics' || filterQueryForm.get('field')?.value =='source' || filterQueryForm.get('field')?.value =='movies' || filterQueryForm.get('field')?.value =='actor_name') && (option == 'ILIKE')){
                                <option [value]="option">{{option}}</option>
                            }
                        }
                    </select>
                    <div class="clause-input">
                        @if(filterQueryForm.get('field')?.value != 'categories'){
                        <input type="text" class="field-input" formControlName="value" placeholder="Enter filter value"
                            [ngClass]="{ 'is-invalid': (isSubmitted() || getClauseControl($index, 'value')?.touched) && getClauseControl($index, 'value')?.invalid }">
                        @if ((isSubmitted() || getClauseControl($index, 'value')?.touched) && hasClauseError($index,
                        'value', 'required')) {
                        <div class="invalid-feedback">Filter value is required</div>
                        }
                        }@else{
                            <app-multi-level-dropdown [title]="'Category'" [items]="categories"
                              (itemChange)="addItemInFormArray($event,$index,'category')" [isSubmitted]="isSubmitted()" 
                             [categoryIds]="selectedCategoryies()" [selectItems]="getCategoryFormArray($index)"
                             (clearAll)="checkedAll(false,[],$index,'category')"  (selectAllChange)="checkedAll($event.event.target.checked,$event,$index, 'category')">

                            </app-multi-level-dropdown>
                        }

                    </div>

                    @if(filterQuery.controls.length > 1){
                    <button class="delete-clause" type="button" (click)="removeClause($index)">
                        <img [src]="binIconPath" alt="Delete" class="bin-icon">
                    </button>
                    }
                </div>
                <div class="clause-options">
                    <div class="form-group">
                        <div class="logical-operator">
                            <label>Logical Operator<span class="requird">*</span></label>
                            <div class="radio-group">
                                <label class="radio-label">
                                    <input type="radio" value="AND" formControlName="logicalOperator">
                                    <span class="radio-custom"></span>
                                    AND
                                </label>

                                <label class="radio-label">
                                    <input type="radio" value="OR" formControlName="logicalOperator">
                                    <span class="radio-custom"></span>
                                    OR
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
      
        <button class="add-filter-btn" type="button" (click)="addClause()">
            + Add Filter
        </button>
        <div class="brand-safety-highlight">
            <div class="brand-safety-row">
                <label>Brand Safety</label>
            </div>
            <p class="helper-text">Apply brand safety to exclude unsafe content from the pool.</p>
            <div class="radio-group">
                <label class="radio-label">
                    <input type="radio" value="true" formControlName="brand_safety">
                    <span class="radio-custom"></span>
                    Yes
                </label>
                <label class="radio-label">
                    <input type="radio" value="false" formControlName="brand_safety">
                    <span class="radio-custom"></span>
                    No
                </label>
            </div>
        </div>
    </div>

    <div class="section">
        <h3>Content Pool Preview</h3>
        <div class="preview-stats">
            <div class="stat-card">
                <h1>{{contentPoolPreview['totalRequest'] || contentPoolPreview['totalRequest'] == 0 ?
                    (contentPoolPreview['totalRequest'] | numberSuffix) : '-'}}</h1>
                <p class="stat-label">Number of Requests</p>
            </div>
            <div class="stat-card">
                <h1>{{contentPoolPreview['totalSuccessRequests'] || contentPoolPreview['totalSuccessRequests'] == 0 ?
                    (contentPoolPreview['totalSuccessRequests'] | numberSuffix) : '-'}}</h1>
                <p class="stat-label">Number of Successful Requests</p>
            </div>
            <div class="stat-card">
                <h1>{{contentPoolPreview['brandSafe'] || contentPoolPreview['brandSafe'] == 0 ?
                    (contentPoolPreview['brandSafe'] | numberSuffix) : '-'}}</h1>
                <p class="stat-label">Brand Safe Matches</p>
            </div>

            <div class="stat-card mapped-assets" (click)="navigateToContentPoolAssets()">
                <h1>{{contentPoolPreview['mappedAssets'] || contentPoolPreview['mappedAssets'] == 0 ?
                    (contentPoolPreview['mappedAssets'] | numberSuffix) : '-'}}</h1>
                <p class="stat-label">Mapped Assets</p>
            </div>
        </div>
    </div>

    <div class="footer">
        <div class="footer-actions">
            <button class="btn-cancel" type="button" (click)="resetForm()">Reset</button>
            <button class="btn-save" [ngClass]="{'disabled':isFilterFilled}" type="button" (click)="saveContentPool()">Run Preview</button>
            @if(!editMode){
                <button class="btn-save" type="button" [ngClass]="{'disabled':runPreview}" (click)="saveContentPool(true)">Save Content Pool</button>
            }@else {
            <button class="btn-save" type="button" [ngClass]="{'disabled':runPreview}"   (click)="updateContentPool()">Update Content Pool</button>
            }
        </div>
    </div>
</div>